import api from './api';
import {
  AgentPipeline,
  AgentPipelineCreate,
  AgentPipelineUpdate,
  PipelineExecution,
} from '../types/pipeline';

const API_BASE_URL = '';

// ---------------------------------------------------------------------------
// Pipeline CRUD
// ---------------------------------------------------------------------------

export async function getPipelines(): Promise<AgentPipeline[]> {
  const response = await api.get(`${API_BASE_URL}/pipelines`);
  return response.data;
}

export async function getPipeline(pipelineId: string): Promise<AgentPipeline> {
  const response = await api.get(`${API_BASE_URL}/pipelines/${pipelineId}`);
  return response.data;
}

export async function createPipeline(payload: AgentPipelineCreate): Promise<AgentPipeline> {
  const response = await api.post(`${API_BASE_URL}/pipelines`, payload);
  return response.data;
}

export async function updatePipeline(
  pipelineId: string,
  updates: AgentPipelineUpdate,
): Promise<AgentPipeline> {
  const response = await api.put(`${API_BASE_URL}/pipelines/${pipelineId}`, updates);
  return response.data;
}

export async function deletePipeline(pipelineId: string): Promise<void> {
  await api.delete(`${API_BASE_URL}/pipelines/${pipelineId}`);
}

// ---------------------------------------------------------------------------
// Execution
// ---------------------------------------------------------------------------

export async function executePipeline(pipelineId: string): Promise<PipelineExecution> {
  // Pipeline runs agent + actions; can take 30–90+ seconds (LLM, Mattermost, etc.)
  const response = await api.post(`${API_BASE_URL}/pipelines/${pipelineId}/execute`, null, {
    timeout: 120_000,
  });
  return response.data;
}

export async function getPipelineExecutions(
  pipelineId: string,
  limit = 20,
): Promise<PipelineExecution[]> {
  const response = await api.get(
    `${API_BASE_URL}/pipelines/${pipelineId}/executions`,
    { params: { limit } },
  );
  return response.data;
}

export async function getPipelineExecution(executionId: string): Promise<PipelineExecution> {
  const response = await api.get(`${API_BASE_URL}/pipelines/executions/${executionId}`);
  return response.data;
}
